import { render, staticRenderFns } from "./ChangeTierInterface.vue?vue&type=template&id=a9232aea&scoped=true"
import script from "./ChangeTierInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeTierInterface.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChangeTierInterface.vue?vue&type=style&index=0&id=a9232aea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9232aea",
  null
  
)

export default component.exports